import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';

const OfflineStudio = lazy(() => import('./pages/OfflineStudio').then((module) => ({ default: module.OfflineStudio })));
const AppWorkspace = lazy(() => import('./pages/AppWorkspace').then((module) => ({ default: module.AppWorkspace })));
const FiscalModule = lazy(() => import('./pages/FiscalModule').then((module) => ({ default: module.FiscalModule })));
const Settings = lazy(() => import('./pages/Settings').then((module) => ({ default: module.Settings })));

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/atlas" element={<Suspense fallback={<div className="empty-state">A abrir o laboratório…</div>}><OfflineStudio /></Suspense>} />
        <Route path="/apps/:moduleId" element={<Suspense fallback={<div className="empty-state">A preparar o espaço de trabalho…</div>}><AppWorkspace /></Suspense>} />
        <Route path="/fiscalidade" element={<Suspense fallback={<div className="empty-state">A carregar o módulo fiscal…</div>}><FiscalModule /></Suspense>} />
        <Route path="/settings" element={<Suspense fallback={<div className="empty-state">A carregar configuração…</div>}><Settings /></Suspense>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
